import Alpine from 'alpinejs';
import React from "react";
import {render} from "react-dom";
import PriceFormat from "../react/common/PriceFormat";

export default (initialPrice, vehicleId, deliveryPackages) => ({
    init() {
        const deliveryPackage = JSON.parse(deliveryPackages)[this.selectedPackage - 1];
        if (deliveryPackage) {
            this.selectPackage(this.selectedPackage, deliveryPackage.price);
        }
    },
    selectedPackage: Alpine.$persist(1).as(`deliverypackage-${vehicleId}`),
    price: initialPrice,

    selectPackage(index, packagePrice) {
        this.selectedPackage = index;
        this.price = render(<PriceFormat value={parseFloat(initialPrice + packagePrice)} />, this.$refs.priceRef);
    },
})
